import { URLs } from '../config/enums';

const avoidSessionCheckRoutes = [URLs.SUGGEST_CANDIDATE, URLs.COMPLETE_SURVEY];

export const mustCheckToken = (route: string): boolean => {
  return avoidSessionCheckRoutes.findIndex((url) => url === route) === -1;
};
